import React, { useEffect } from "react";
import { useGetApplicationQuery, usePostUpsertApplicationMutation } from "@/store/service";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ApplicationStep } from "@/enum/ApplicationStep";
import { isDebugForms, getDebugNextStepUrl } from "@/util/debug";
import { selfDeclarationSchema, SelfDeclarationFormData } from "@/model/schemas";
import { zodFormResolver } from "@/util/form";
import SelfDeclarationForm from "./SelfDeclaration";

const SelfDeclarationWrapper = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { data: application } = useGetApplicationQuery(params.id!);
  const [postApplication, postApplicationResult] = usePostUpsertApplicationMutation();

  const form = useForm<SelfDeclarationFormData>({
    resolver: zodFormResolver<SelfDeclarationFormData>(selfDeclarationSchema),
    mode: "onTouched",
    defaultValues: {
      declarantName: "",
      declarantAddress: "",
      declaredIncome: 0,
      canMeetCommitment: false,
    },
  });
  const { handleSubmit, getValues } = form;

  useEffect(() => {
    if (postApplicationResult.isSuccess) {
      navigate(`/application/${postApplicationResult.data.id}/${postApplicationResult.data.step}`);
    }
  }, [postApplicationResult.isSuccess]);

  const onSubmit = async (data: SelfDeclarationFormData) => {
    await postApplication({ id: params.id!, step: ApplicationStep.SelfDeclaration, selfDeclaration: data });
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isDebugForms()) {
      navigate(getDebugNextStepUrl(params.id!, ApplicationStep.SelfDeclaration));
    } else {
      handleSubmit(onSubmit)(e);
    }
  };

  return (
    <form onSubmit={handleFormSubmit} className="relative">
      <div className="w-full max-w-2xl mx-auto space-y-5">
        <h3 className="text-2xl font-semibold text-gray-900 text-center">Self Declaration</h3>
        <SelfDeclarationForm form={form} />
        <div className="flex justify-center pt-2">
          <button
            type="submit"
            name="submit"
            className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
          >
            Continue
          </button>
        </div>
      </div>
    </form>
  );
};

export default SelfDeclarationWrapper;
